module.exports = __webpack_public_path__ + "static/media/letter.6cc25844.svg";